var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendarWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 7.59 8.15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_2tCsU6",
    "data-name": "2tCsU6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1.53.9V.3A.29.29,0,0,1,1.79,0a.3.3,0,0,1,.32.22.34.34,0,0,1,0,.1V.9H5.33V.31A.3.3,0,0,1,5.63,0a.3.3,0,0,1,.3.3V.9H7a.57.57,0,0,1,.59.59V7.56A.58.58,0,0,1,7,8.15H.59A.58.58,0,0,1,0,7.56V1.49A.57.57,0,0,1,.59.9h.94ZM.45,3.06V7.3a.4.4,0,0,0,.42.42H6.79a.35.35,0,0,0,.35-.35c0-1.42,0-2.84,0-4.26v0ZM5.33,1.3a.44.44,0,0,0-.14.49.47.47,0,0,0,.46.31.45.45,0,0,0,.43-.37.44.44,0,0,0-.15-.43v.33a.3.3,0,1,1-.6,0Zm-3.21,0v.35a.3.3,0,0,1-.3.3.29.29,0,0,1-.29-.31V1.29a.46.46,0,0,0-.06.65.47.47,0,0,0,.68,0A.46.46,0,0,0,2.12,1.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M5.38,5.36V5.09a.17.17,0,0,1,.17-.18h.56a.18.18,0,0,1,.18.18v.55a.17.17,0,0,1-.18.18H5.56a.17.17,0,0,1-.18-.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M5.38,4V3.74a.17.17,0,0,1,.18-.18h.55a.16.16,0,0,1,.17.16,5.61,5.61,0,0,1,0,.58.16.16,0,0,1-.17.16H5.55a.16.16,0,0,1-.17-.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M3.57,4v.28a.16.16,0,0,1-.17.17H2.83a.16.16,0,0,1-.17-.17V3.73a.17.17,0,0,1,.18-.17,5.23,5.23,0,0,1,.56,0,.16.16,0,0,1,.17.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M4.93,4v.27q0,.18-.18.18H4.2A.17.17,0,0,1,4,4.28V3.73a.16.16,0,0,1,.17-.17,5.23,5.23,0,0,1,.56,0,.17.17,0,0,1,.18.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2.21,4v.28a.16.16,0,0,1-.16.17H1.47a.15.15,0,0,1-.16-.16,5.61,5.61,0,0,1,0-.58.15.15,0,0,1,.16-.16,5.42,5.42,0,0,1,.57,0,.16.16,0,0,1,.17.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1.31,5.36a2.43,2.43,0,0,1,0-.27.16.16,0,0,1,.17-.18H2a.17.17,0,0,1,.18.18v.55A.16.16,0,0,1,2,5.82H1.47a.16.16,0,0,1-.16-.17h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M4.93,5.37v.27a.17.17,0,0,1-.18.18H4.2A.17.17,0,0,1,4,5.64V5.09a.17.17,0,0,1,.18-.18h.55a.17.17,0,0,1,.18.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M4,6.77V6.49a.16.16,0,0,1,.17-.17,5.42,5.42,0,0,1,.57,0,.15.15,0,0,1,.16.16,5.42,5.42,0,0,1,0,.57.16.16,0,0,1-.16.17H4.19A.16.16,0,0,1,4,7.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2.66,5.36V5.08a.16.16,0,0,1,.17-.17H3.4a.16.16,0,0,1,.17.16v.58a.16.16,0,0,1-.17.16H2.83a.16.16,0,0,1-.17-.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1.76,7.22H1.48A.16.16,0,0,1,1.31,7a5,5,0,0,1,0-.55.15.15,0,0,1,.17-.17H2a.16.16,0,0,1,.17.17v.56A.16.16,0,0,1,2,7.22H1.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M3.57,6.77v.28a.16.16,0,0,1-.16.17H2.82a.16.16,0,0,1-.16-.16V6.48a.16.16,0,0,1,.17-.16,5.42,5.42,0,0,1,.57,0,.16.16,0,0,1,.17.16Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarWhite);
export default __webpack_public_path__ + "static/media/Calendar White.cee6055a0858e582a4ccbba0c23dc24b.svg";
export { ForwardRef as ReactComponent };